import { render, staticRenderFns } from "./polioli.vue?vue&type=template&id=5bbba15d&"
import script from "./polioli.vue?vue&type=script&lang=js&"
export * from "./polioli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports